import React from "react";
import { Tabs, Layout } from "antd";
import UsersList from "./UsersList";
import PendingInvitations from "../registration/components/PendingInvitations";
import { FormattedMessage } from "react-intl";
import { loadPage } from "./usersSlice";
import { loadPage as loadPending } from "../registration/registrationSlice";
import { useDispatch } from "react-redux";
import Surface from "../../components/layouts/Surface";

const Users = (props) => {
  const dispatch = useDispatch();

  const onChange = (key) => {
    if (key === "users_list") {
      dispatch(loadPage());
    } else if (key === "pending_invitations") {
      dispatch(loadPending());
    }
  };
  return (
    <Layout>
      <Tabs
        defaultActiveKey="users_list"
        onChange={onChange}
        items={[
          {
            label: <FormattedMessage id="app.users.users_list" />,
            key: "users_list",
            children: (
              <Surface>
                <UsersList />
              </Surface>
            ),
          },
          {
            label: <FormattedMessage id="app.users.pending_invitations" />,
            key: "pending_invitations",
            children: (
              <Surface>
                <PendingInvitations />
              </Surface>
            ),
          },
        ]}
      ></Tabs>
    </Layout>
  );
};

export default Users;
